<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <div class="app-l-page__breadcrumbs">
                <ul class="breadcrumbs-list">
                    <li translate class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series']" translate
                            >series.title</a
                        >
                    </li>
                    <li class="breadcrumbs-list-item" translate>
                        <a [routerLink]="['/app/series/audio']" translate
                            >series.seriesTypes.audio</a
                        >
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        translate>
                        series.voiceSeries.stories
                    </li>
                </ul>
            </div>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h1 class="app-l-voices-banner__heading" translate>
                    series.voiceSeries.stories
                </h1>
                <!-- <h6 class="app-l-voices-banner__desc" translate>
                    Lorem ipsum dolor sit amet consectetur. Tortor sit vel.
                </h6> -->
            </div>
        </div>
    </div>
</div>

<div class="voice-series-main-container">
    <page-loader *ngIf="!loaded"></page-loader>
    <div class="series-type-section" *ngIf="loaded">
        <div class="app-l-sub-title-holder">
            <div class="app-l-subTitle">
                <!-- <span translate>series.voiceSeries.stories</span> -->
            </div>
            <div class="app-c-mat-select">
                <mat-select
                    [(ngModel)]="categorySelected"
                    class="app-l-dsh__cat_select"
                    [(value)]="selectedOption"
                    panelClass="app-l-dsh__cat_panel"
                    (selectionChange)="getFilteredList()">
                    <ng-container *ngFor="let category of categoryList">
                        <mat-option
                            *ngIf="category.hasStories > 0"
                            [value]="category.ID"
                            translate>
                            {{ category.Title }}
                            <!-- <mat-radio-button
                            [(ngModel)]="selectedOption"
                            [value]="option.value">
                            {{ option.label }}
                        </mat-radio-button> -->
                        </mat-option>
                    </ng-container>
                </mat-select>
            </div>
        </div>
        <div class="series-type-list">
            <ng-container *ngFor="let story of filteredStoryList">
                <div
                    class="series-type-card type-allen"
                    (click)="goToVoiceStory(story)">
                    <div class="cover-image-section">
                        <img
                            [defaultImage]="
                                '../../../assets/img/series/voice-stories-bg.svg'
                            "
                            [lazyLoad]="story.imageUrl" />
                    </div>

                    <!-- <div
						class="cover-image-section"
						[ngClass]="{ 'default-bg': !story.ImageUrl }"
						[ngStyle]="{
							'background-image': story.ImageUrl
								? 'url(' + story.ImageUrl + ')'
								: 'none'
						}"
						(click)="goToVoiceStory(story)"></div> -->

                    <div class="card-content" translate>
                        {{ story ? story['title_' + lang] : '' }}
                        <span>{{ story ? story['author_' + lang] : '' }}</span>
                    </div>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="filteredStoryList.length == 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
</div>
